import Grid from "@mui/material/Grid2"
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { primitiveAccessPointColor } from "../../utilities/buffaloArcGisHelper"
import { toLegibleOnBlack } from "../../utilities/colorHelper"
import { isPrimitiveAccessPoint } from "../../utilities/tripHelper"

interface PrimitiveAccessWarningProps {
    accessPointNames: string[]
    compact?: boolean
}

// Shown wherever a primitive access point is part of a trip, before any trip
// numbers, so the road and facilities caveat is seen before a trip gets planned
// around it. Renders nothing when none of the given points are primitive.
export const PrimitiveAccessWarning = (props: PrimitiveAccessWarningProps) => {
    const primitiveNames = props.accessPointNames.filter(isPrimitiveAccessPoint)
    if (primitiveNames.length === 0) return null

    const legibleColor = toLegibleOnBlack(primitiveAccessPointColor)
    const subject = primitiveNames.length === 1
        ? `${primitiveNames[0]} is a primitive access`
        : `${primitiveNames.join(" and ")} are primitive accesses`

    return (
        <Grid
            container
            size={12}
            spacing={1}
            sx={{
                backgroundColor: "#1a1a1a",
                borderLeft: `4px solid ${primitiveAccessPointColor}`,
                borderRadius: "4px",
                padding: props.compact ? "6px 10px" : "10px 15px",
                alignItems: "flex-start",
                flexWrap: "nowrap",
                fontSize: props.compact ? "13px" : undefined
            }}
        >
            <Grid>
                <WarningAmberOutlinedIcon sx={{ color: legibleColor, fontSize: props.compact ? "18px" : undefined }} />
            </Grid>
            <Grid size="grow">
                <span style={{ color: legibleColor }}>{subject}.</span>
                {" "}Expect an unimproved road, limited parking, and no facilities. A high-clearance vehicle may be needed, especially after rain.
            </Grid>
        </Grid>
    )
}
